import { nextTick } from 'vue';

export async function loadLocaleMessages(i18n, locale) {
  const messages = await import(
    /* webpackChunkName: "lang-[request]" */ `../lang/i18n/${locale}.json`
  );
  i18n.global.setLocaleMessage(locale, messages.default);
  return nextTick();
}
